import { render, staticRenderFns } from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=template&id=a7deff7a&scoped=true"
import script from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=style&index=0&id=a7deff7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7deff7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7deff7a')) {
      api.createRecord('a7deff7a', component.options)
    } else {
      api.reload('a7deff7a', component.options)
    }
    module.hot.accept("./QuoteBuilderSubletHeadingsComponent.vue?vue&type=template&id=a7deff7a&scoped=true", function () {
      api.rerender('a7deff7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderSublets/QuoteBuilderSubletHeadingsComponent.vue"
export default component.exports